import { NgModule } from '@angular/core';
import { NgNoCheck } from './ng-no-check';

@NgModule({
  declarations: [ NgNoCheck ],
  exports: [ NgNoCheck ],
})
export class ContribNgNoCheckModule { }
